import React, { useContext } from 'react';
import { LocaleContext } from 'containers/LocaleContext';
import Icon from 'components/Icon';
import LanguageDropdown from 'components/LanguageDropdown';
import Text from 'components/Text';
import { useNavigate } from 'react-router-dom';
const Header = (props) => {
    const { I18n, changeLocale, translation } = useContext(LocaleContext);
    const navigate = useNavigate();
    return (React.createElement("div", { id: "header", "data-testid": "header" },
        props.withGoBack && (React.createElement("div", { className: "go_back", "data-testid": "go_back", onClick: () => navigate(-1) },
            React.createElement(Icon.Base, { icon: "arrow-left" }),
            React.createElement(Text.Base, null, translation('buttons.back')))),
        !props.withGoBack && React.createElement("img", { className: "logo", src: require(`assets/svgs/Logo.svg`), alt: "fastned_logo" }),
        props.withGoBack && (React.createElement("img", { className: "logo_icon", src: require(`assets/svgs/Logo_Icon.svg`), alt: "fastned_mini_logo" })),
        React.createElement(LanguageDropdown, { title: I18n.t('shared.select_your_language'), selection: I18n.locale, options: [
                { title: 'EN', value: 'en' },
                { title: 'NL', value: 'nl' },
                { title: 'DE', value: 'de' },
                { title: 'FR', value: 'fr' },
            ], onSelect: changeLocale })));
};
export default Header;
